import NewTariffFeaturePage from './NewTariffFeaturePage';

export default NewTariffFeaturePage;
